import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';

export default function AccountSecurityNotice() {
  const { user } = useAuth();
  const [notice, setNotice] = useState(null);
  useEffect(() => {
    let active = true;
    setNotice(null);
    const load = () => user?.id && api.get('/account-security/status').then(({data}) => {
      if (active) setNotice(data.held ? data : null);
    }).catch(() => {});
    const held = event => { if (active) setNotice({ message: event.detail.msg }); };
    load();
    window.addEventListener('dayone:account-verification', held);
    const interval = window.setInterval(load, 60000);
    return () => { active = false; window.clearInterval(interval); window.removeEventListener('dayone:account-verification', held); };
  }, [user?.id]);
  if (!user?.id || !notice) return null;
  return <aside role="alert" className="mx-auto my-4 max-w-4xl rounded-2xl border border-amber-400/40 bg-amber-950/40 p-5 text-amber-100">
    <h2 className="mb-2 font-bold">🛡️ Vérification de sécurité DayOne FC</h2>
    <p className="text-sm leading-relaxed">{notice.message}</p>
    <Link to="/tickets/new" className="mt-3 inline-block rounded-xl bg-amber-100 px-4 py-2 font-bold text-amber-950">Contacter le support</Link>
  </aside>;
}
